export const getUserInfo = state => state.userInfo
export const getMenus = state => state.menus
export const getAdState = state => state.isAdmin
export const getRandomStr = state => state.randomStr
export const getShowVerity = state => state.showVerity

export const isXkwAdmin = state => {
    let isAdmin = false
    let roles = state.userInfo.roles
    if (roles) {
        // SCHOOL_ADMIN("918071701", "管理员", 3, "校领导", "school"),
        // REGION_SUPPER_ADMIN("718071701", "超级管理员", 8, "信息化管理员", "region"),
        const target = roles.find(item => item.roleCode === '918071701' || item.roleCode === '718071701')
        if (target) {
            return true
        }
    }
    return isAdmin
}

export const isTest = () => {
    return process.env.NODE_ENV !== 'production'
}

// 是否是灰度用户
export const isGrayscaleUser = state => {
    return (state.userInfo.productPermissionIds || []).indexOf('YJOT') >= 0
 }

 export const jumpCodes = state => {
    return ['Region-Answer-Sheet-Production', 'Region-Exam-Single', 'Region-Exam-Wuhen']
 }



// WEBPACK FOOTER //
// ./src/vuex/modules/login/getters.js